// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "embed-popup-" + chunkId + "." + {"125":"738d8d9e","410":"4fbe9dff","693":"863ce7ad","934":"4c4ea8e9"}[chunkId] + ".js";
};